module.exports = __webpack_public_path__ + "img/macchiato.9500a345.png";